import { SelectionColumn, SelectionItem } from "./SelectionColumn";

export interface GradeColumnProps {
  grades: SelectionItem[];
  selectedGrades: string[];
  onGradeChange: (value: string) => void;
  allowMultipleSelection?: boolean;
  customWidth?: string;
}

export const GradeColumn = ({
  grades,
  selectedGrades,
  onGradeChange,
  allowMultipleSelection = false,
  customWidth,
}: GradeColumnProps) => {
  return (
    <SelectionColumn
      title="Grade"
      data={grades}
      selectedItems={selectedGrades}
      onSelectionChange={onGradeChange}
      valueField="Value"
      titleField="Title"
      layoutMode="dynamic"
      isNarrowColumn={false}
      showTitleDivider={true}
      allowMultipleSelection={allowMultipleSelection}
      customWidth={customWidth}
    />
  );
};
